import { RoleSortField } from "@/graphql/codegen/graphql"

export type RoleSortableAccessorKey = "name"

export const accessorKeyToRoleSortField = new Map<RoleSortableAccessorKey, RoleSortField>([
  ["name", RoleSortField.Role],
])

export const roleSortFieldToAccessoryKey = new Map<RoleSortField, RoleSortableAccessorKey>([
  [RoleSortField.Role, "name"],
])
